import { Stack, Box } from '@mui/material'
import { ReactNode } from 'react'

type CommonStepContentProps = {
  children: ReactNode
  imageSrc?: string
  alt?: string
}

export const CommonStepContent = ({ children, imageSrc, alt }: CommonStepContentProps) => (
  <Stack>
    {children}
    {imageSrc && (
      <Box maxHeight={500} maxWidth={500} mx="auto">
        <img src={imageSrc} style={{ width: '100%', height: '100%', objectFit: 'contain' }} alt={alt} />
      </Box>
    )}
  </Stack>
)
